module.exports = __webpack_public_path__ + "img/xunjian2.99d34d00.svg";